import { createVNode as _createVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/chevronLeft.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-1c60f2be")

_pushScopeId("data-v-1c60f2be")
const _hoisted_1 = { class: "genericPadding hasHeader bgWhite" }
const _hoisted_2 = { class: "header withShadow d-flex aling-items-center justify-content-between py-4" }
const _hoisted_3 = /*#__PURE__*/_createVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "sideContainer" }, null, -1)
const _hoisted_5 = { class: "d-flex flex-column align-items-center mt-5" }
const _hoisted_6 = { class: "d-flex text-left align-items-center" }
const _hoisted_7 = { class: "text " }
const _hoisted_8 = { key: 0 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _directive_userimage = _resolveDirective("userimage")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", {
        class: "sideContainer",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
      }, [
        _hoisted_3
      ]),
      _createVNode(_component_localized_text, {
        class: "fs_12 greyBlue",
        localizedKey: "app_richiestedingresso",
        text: "Richieste d'ingresso"
      }),
      _hoisted_4
    ]),
    _createVNode("div", _hoisted_5, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.list, (item, i) => {
        return (_openBlock(), _createBlock("div", {
          class: "reteItem d-flex px-4",
          key: i
        }, [
          _createVNode("div", _hoisted_6, [
            _withDirectives((_openBlock(), _createBlock("div", {
              class: "reteImage mr-4",
              key: item.identifier
            }, null, 512)), [
              [_directive_userimage, _ctx.$store.state.getUserImage(item.to.identifier)]
            ]),
            _createVNode("div", null, [
              _createVNode(_component_localized_text, {
                localizedKey: "app_community",
                text: "Community",
                class: "text d-block"
              }),
              _createVNode("span", _hoisted_7, _toDisplayString(item.from.name), 1)
            ])
          ]),
          _createVNode("div", null, [
            _createVNode("button", {
              class: "btn",
              onClick: ($event: any) => (_ctx.accept(item))
            }, [
              _createVNode(_component_localized_text, {
                localizedKey: "app_accetta",
                text: "Accetta",
                class: "text_uppercase"
              })
            ], 8, ["onClick"]),
            _createVNode("button", {
              class: "btn",
              onClick: ($event: any) => (_ctx.deny(item))
            }, [
              _createVNode(_component_localized_text, {
                localizedKey: "app_rifiuta",
                text: "Rifiuta",
                class: "text_uppercase"
              })
            ], 8, ["onClick"])
          ])
        ]))
      }), 128)),
      (_ctx.list.length == 0)
        ? (_openBlock(), _createBlock("div", _hoisted_8, [
            _createVNode(_component_localized_text, {
              localizedKey: "app_nessuninvitotrovato",
              text: "Nessun invito trovato!",
              class: "fs_14 grey d-block text-center"
            })
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
})